import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import AuctionSelfInspection from './AuctionSelfInspection';
import { getEngCarName } from '../utils/carNames';

// 경매 출품 모달 — 2단계 (차량선택 → 경매정보)
function AuctionListingModal(props){
  var user=props.user;
  var onClose=props.onClose;
  var onSuccess=props.onSuccess;

  var[step,setStep]=useState(1);
  var[cars,setCars]=useState([]);
  var[activeCarIds,setActiveCarIds]=useState({}); // carId → auctionId (이미 출품 중)
  var[loading,setLoading]=useState(true);
  var[loadError,setLoadError]=useState('');
  var[selectedCarId,setSelectedCarId]=useState(null);
  var[searchQ,setSearchQ]=useState('');

  // Step 2 폼 상태
  var[title,setTitle]=useState('');
  var[durationHours,setDurationHours]=useState(48);
  var[description,setDescription]=useState('');
  var[submitting,setSubmitting]=useState(false);
  var[submitError,setSubmitError]=useState('');
  var[showSelfInspection,setShowSelfInspection]=useState(false);
  var[selfInspection,setSelfInspection]=useState({paintData:{},damageData:{}});

  // 차량 + 내 출품 목록 병렬 로드
  useEffect(function(){
    var cid=(user&&(user.activeCompanyId||user.companyId))||0;
    var carsUrl=cid>0?API+'/cars?companyId='+cid:API+'/cars';
    setLoading(true);
    setLoadError('');
    Promise.all([
      authFetch(carsUrl).then(function(r){return r.json()}).catch(function(){return []}),
      authFetch(API+'/auctions/my-listings').then(function(r){return r.json()}).catch(function(){return {success:false}})
    ]).then(function(results){
      var carsData=results[0];
      var mylData=results[1];
      if(Array.isArray(carsData)){
        setCars(carsData);
      }else{
        setCars([]);
        setLoadError('차량 목록을 불러올 수 없습니다');
      }
      var activeMap={};
      if(mylData&&mylData.success&&mylData.data&&Array.isArray(mylData.data.listings)){
        mylData.data.listings.forEach(function(a){
          if(a&&a.status&&['active','pending','pending_selection'].indexOf(a.status)>=0){
            if(a.car&&a.car.id)activeMap[a.car.id]=a.id;
          }
        });
      }
      setActiveCarIds(activeMap);
    }).catch(function(){setLoadError('서버 연결 실패')}).then(function(){setLoading(false)});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  var filteredCars=cars.filter(function(c){
    if(!searchQ)return true;
    var q=searchQ.toLowerCase();
    return (c.carNo||'').toLowerCase().indexOf(q)>=0
      ||(c.carType||'').toLowerCase().indexOf(q)>=0
      ||(c.vin||'').toLowerCase().indexOf(q)>=0;
  });

  var selectedCar=cars.find(function(c){return c.id===selectedCarId});

  var goStep2=function(){
    if(!selectedCarId)return;
    // 기본 제목 자동 생성
    var c=selectedCar;
    if(c){
      var yr=c.regDate?String(c.regDate).slice(0,4)+'년 ':'';
      setTitle((yr+getEngCarName(c.carType||'')).trim()||'경매 출품');
    }
    setDescription('');
    setSubmitError('');
    setShowSelfInspection(false);
    setSelfInspection({paintData:{},damageData:{}});
    setStep(2);
  };

  var goStep1=function(){
    setStep(1);
    setSubmitError('');
  };

  var parseMan=function(s){return parseInt(String(s||'').replace(/[^0-9]/g,''))||0};
  var formatMan=function(n){return n?Number(n).toLocaleString():''};

  var handleSubmit=function(){
    if(submitting)return;
    setSubmitting(true);
    setSubmitError('');
    var body={
      carId:selectedCarId,
      title:(title||'').trim(),
      description:(description||'').trim(),
      durationHours:durationHours
    };
    // 셀프 검차 (eval 없을 때만 백엔드가 채택)
    if(showSelfInspection){
      var hasPaint=Object.keys(selfInspection.paintData||{}).length>0;
      var hasDmg=Object.keys(selfInspection.damageData||{}).length>0;
      if(hasPaint||hasDmg){
        body.selfInspection={
          paintData:selfInspection.paintData||{},
          damageData:selfInspection.damageData||{},
          score:selfInspection.score
        };
      }
    }
    authFetch(API+'/auctions',{method:'POST',body:JSON.stringify(body)})
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success){
          if(onSuccess)onSuccess(d.data&&d.data.auction);
        }else{
          setSubmitError((d&&d.error)||'출품 실패');
        }
      })
      .catch(function(){setSubmitError('서버 연결 실패')})
      .then(function(){setSubmitting(false)});
  };

  // ────────── 렌더 ──────────
  return (
    <div onClick={onClose}
      style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9998,padding:16}}>
      <div onClick={function(e){e.stopPropagation()}}
        style={{background:'#fff',borderRadius:16,width:'100%',maxWidth:520,maxHeight:'90vh',display:'flex',flexDirection:'column',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>

        {/* 헤더 */}
        <div style={{padding:'16px 20px',borderBottom:'1px solid #e5e7eb',display:'flex',alignItems:'center',justifyContent:'space-between',flexShrink:0}}>
          <div style={{display:'flex',alignItems:'center',gap:10}}>
            {step===2&&(
              <button onClick={goStep1} disabled={submitting}
                style={{background:'none',border:'none',fontSize:18,cursor:submitting?'wait':'pointer',color:'#475569',padding:0}}>←</button>
            )}
            <div style={{fontSize:16,fontWeight:800,color:'#1B3A5C'}}>
              {step===1?'🏛️ 차량 출품하기':'📝 경매 정보 입력'}
            </div>
            <div style={{fontSize:11,color:'#94a3b8',fontWeight:600}}>Step {step}/2</div>
          </div>
          <button onClick={onClose}
            style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#94a3b8',padding:4}}>✕</button>
        </div>

        {/* 본문 */}
        <div style={{flex:1,overflowY:'auto',padding:'18px 20px'}}>
          {step===1?(
            <div>
              {/* 검색 */}
              <div style={{display:'flex',alignItems:'center',gap:6,padding:'8px 12px',background:'#f8fafc',border:'1px solid #e2e8f0',borderRadius:8,marginBottom:12}}>
                <span style={{fontSize:14,color:'#94a3b8'}}>🔍</span>
                <input value={searchQ} onChange={function(e){setSearchQ(e.target.value)}}
                  placeholder="차종 / 차량번호 / VIN 검색..."
                  style={{flex:1,border:'none',outline:'none',background:'transparent',fontSize:12}}/>
                {searchQ&&(
                  <button onClick={function(){setSearchQ('')}}
                    style={{background:'none',border:'none',color:'#94a3b8',cursor:'pointer',fontSize:12,padding:0}}>✕</button>
                )}
              </div>

              {/* 로딩 */}
              {loading&&(
                <div style={{padding:40,textAlign:'center',color:'#94a3b8',fontSize:13}}>불러오는 중...</div>
              )}

              {/* 에러 */}
              {loadError&&!loading&&(
                <div style={{padding:'10px 12px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,color:'#dc2626',fontSize:12,marginBottom:10}}>
                  ⚠ {loadError}
                </div>
              )}

              {/* 빈 상태 */}
              {!loading&&!loadError&&cars.length===0&&(
                <div style={{padding:'40px 20px',textAlign:'center',background:'#f8fafc',borderRadius:8,color:'#94a3b8'}}>
                  <div style={{fontSize:42,marginBottom:10,opacity:0.4}}>🚗</div>
                  <div style={{fontSize:13,fontWeight:700,color:'#64748b'}}>등록된 차량이 없습니다</div>
                  <div style={{fontSize:11,marginTop:4}}>먼저 차량등록을 해주세요</div>
                </div>
              )}

              {/* 차량 리스트 */}
              {!loading&&filteredCars.length>0&&(
                <div style={{display:'flex',flexDirection:'column',gap:8}}>
                  {filteredCars.map(function(c){
                    var isActive=!!activeCarIds[c.id];
                    var isSelected=c.id===selectedCarId;
                    var yr=c.regDate?String(c.regDate).slice(0,4):'';
                    var mileage=c.mileage?Number(c.mileage).toLocaleString()+'km':'';
                    return (
                      <div key={c.id}
                        onClick={function(){if(!isActive)setSelectedCarId(c.id)}}
                        style={{padding:'12px 14px',borderRadius:8,border:isSelected?'2px solid #1B3A5C':'1px solid #e5e7eb',background:isActive?'#f1f5f9':isSelected?'#eff6ff':'#fff',cursor:isActive?'not-allowed':'pointer',opacity:isActive?0.6:1,transition:'all 0.15s'}}>
                        <div style={{display:'flex',alignItems:'center',gap:10}}>
                          <div style={{width:18,height:18,borderRadius:'50%',border:'2px solid '+(isSelected?'#1B3A5C':'#cbd5e1'),display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                            {isSelected&&<div style={{width:8,height:8,borderRadius:'50%',background:'#1B3A5C'}}/>}
                          </div>
                          <div style={{flex:1,minWidth:0}}>
                            <div style={{display:'flex',alignItems:'center',gap:6,flexWrap:'wrap'}}>
                              <div style={{fontSize:14,fontWeight:700,color:'#0f172a'}}>{c.carNo||'차량번호 없음'}</div>
                              <div style={{fontSize:12,color:'#475569',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{getEngCarName(c.carType||'')}</div>
                              {isActive&&(
                                <span style={{padding:'2px 8px',background:'#fef3c7',color:'#92400e',borderRadius:4,fontSize:10,fontWeight:700}}>출품 중</span>
                              )}
                            </div>
                            <div style={{fontSize:11,color:'#94a3b8',marginTop:3}}>
                              {yr&&yr+'년 '}{mileage}{c.vin?' · VIN '+String(c.vin).slice(-6):''}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              {!loading&&filteredCars.length===0&&cars.length>0&&(
                <div style={{padding:20,textAlign:'center',color:'#94a3b8',fontSize:12}}>검색 결과가 없습니다</div>
              )}
            </div>
          ):(
            <div>
              {/* 선택 차량 요약 */}
              <div style={{padding:'10px 12px',background:'#eff6ff',border:'1px solid #bfdbfe',borderRadius:8,marginBottom:16}}>
                <div style={{fontSize:10,color:'#64748b',marginBottom:2,fontWeight:600}}>선택 차량</div>
                <div style={{fontSize:13,fontWeight:700,color:'#1B3A5C'}}>
                  {selectedCar?(selectedCar.carNo||'')+' '+getEngCarName(selectedCar.carType||''):''}
                </div>
              </div>

              {/* 제목 */}
              <div style={{marginBottom:14}}>
                <label style={{display:'block',fontSize:11,fontWeight:700,color:'#64748b',marginBottom:6}}>경매 제목</label>
                <input value={title} onChange={function(e){setTitle(e.target.value.substring(0,100))}}
                  disabled={submitting}
                  placeholder="예: 2024 그랜저 하이브리드 완전무사고"
                  style={{width:'100%',padding:'10px 12px',border:'1px solid #cbd5e1',borderRadius:6,fontSize:13,outline:'none',boxSizing:'border-box'}}/>
              </div>

              {/* 경매 기간 */}
              <div style={{marginBottom:14}}>
                <label style={{display:'block',fontSize:11,fontWeight:700,color:'#64748b',marginBottom:6}}>경매 기간 <span style={{color:'#ef4444'}}>*</span></label>
                <div style={{display:'flex',gap:6}}>
                  {[24,48,72].map(function(h){
                    var active=durationHours===h;
                    return (
                      <button key={h} onClick={function(){setDurationHours(h)}} disabled={submitting}
                        style={{flex:1,padding:'10px 0',background:active?'#1B3A5C':'#f8fafc',color:active?'#fff':'#475569',border:active?'2px solid #1B3A5C':'1px solid #cbd5e1',borderRadius:6,fontSize:13,fontWeight:700,cursor:submitting?'wait':'pointer'}}>
                        {h}시간
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* 설명 */}
              <div style={{marginBottom:14}}>
                <label style={{display:'block',fontSize:11,fontWeight:700,color:'#64748b',marginBottom:6}}>설명 (선택)</label>
                <textarea value={description} onChange={function(e){setDescription(e.target.value.substring(0,1000))}}
                  disabled={submitting}
                  placeholder="신차급 컨디션, 1인 소유, 무사고 등..."
                  style={{width:'100%',minHeight:80,padding:'10px 12px',border:'1px solid #cbd5e1',borderRadius:6,fontSize:12,resize:'vertical',fontFamily:'inherit',outline:'none',boxSizing:'border-box',lineHeight:1.5}}/>
              </div>

              {/* 셀프 검차 입력 (eval 없을 때만 채택됨) */}
              <div style={{marginBottom:14}}>
                <button type="button" onClick={function(){setShowSelfInspection(!showSelfInspection)}} disabled={submitting}
                  style={{width:'100%',padding:'10px 12px',background:showSelfInspection?'#eff6ff':'#f8fafc',border:'1px solid '+(showSelfInspection?'#1B3A5C':'#e2e8f0'),borderRadius:8,fontSize:12,fontWeight:700,color:showSelfInspection?'#1B3A5C':'#475569',cursor:submitting?'wait':'pointer',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                  <span>🔍 검차 정보 직접 입력 (선택)</span>
                  <span style={{fontSize:10}}>{showSelfInspection?'▲':'▼'}</span>
                </button>
                {showSelfInspection&&(
                  <div style={{marginTop:10}}>
                    <div style={{fontSize:10,color:'#94a3b8',lineHeight:1.5,marginBottom:8}}>
                      ℹ️ 차량평가로 검차된 차량은 자동 연동됩니다. 수동 입력은 평가 데이터가 없을 때만 반영됩니다.
                    </div>
                    <AuctionSelfInspection value={selfInspection} onChange={setSelfInspection}/>
                  </div>
                )}
              </div>

              {/* 경고 */}
              <div style={{padding:'10px 12px',background:'#fff7ed',border:'1px solid #fed7aa',borderRadius:8,fontSize:11,color:'#9a3412',lineHeight:1.6,marginBottom:12}}>
                ⚠ 출품 후 입찰이 있으면 취소 시 신뢰도 페널티가 부과됩니다<br/>
                ℹ️ 검차 정보는 차량평가 연동 또는 직접 입력으로 표시됩니다
              </div>

              {/* 에러 */}
              {submitError&&(
                <div style={{padding:'10px 12px',background:'#fef2f2',border:'1px solid #fecaca',borderRadius:8,fontSize:12,color:'#dc2626',marginBottom:12}}>
                  {submitError}
                </div>
              )}
            </div>
          )}
        </div>

        {/* 하단 액션 */}
        <div style={{padding:'14px 20px',borderTop:'1px solid #e5e7eb',flexShrink:0}}>
          {step===1?(
            <button onClick={goStep2} disabled={!selectedCarId||loading}
              style={{width:'100%',padding:'13px 0',background:(!selectedCarId||loading)?'#cbd5e1':'#1B3A5C',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:800,cursor:(!selectedCarId||loading)?'not-allowed':'pointer'}}>
              다음 →
            </button>
          ):(
            <button onClick={handleSubmit} disabled={submitting||!selectedCarId}
              style={{width:'100%',padding:'13px 0',background:(submitting||!selectedCarId)?'#cbd5e1':'#1B3A5C',color:'#fff',border:'none',borderRadius:8,fontSize:14,fontWeight:800,cursor:submitting?'wait':'pointer'}}>
              {submitting?'출품 중...':'🏛️ 출품하기'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default AuctionListingModal;
